import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import SellerInfo from "../../store/sellerInfo";
import StoreBranches from "../../store/storeBranches";
import Sellers from "../../store/storeCategories/sellers";
import StoreTab from "../../store/storeTab";
import Wallet from "../../wallet/wallet";
import WalletFlow from "../../walletFlow/walletFlow";
import PurchaseRecordDetail from "../homeTab/purchaseRecords/purchaseRecordDetial";
import { TStoreState } from "./IStoreContainer";
import { TStoreContainer } from "./TStoreContainer";


export default function StoreContainer({ setTabChild }: { setTabChild: (id: number) => void }) {
    const [state, setState] = useState<TStoreState>('store');
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState) as TStoreState;
    const stateReduxBottomNav = useSelector((state: RootState) => state.loansTabComponents.prevState);


    useEffect(() => {
        if (stateFromRedux.includes('store')) {
            const newCleanUrl = `${window.location.origin}/#/`;
            window.history.replaceState(null, '', newCleanUrl);
            setState('store')
        }
        else if (stateFromRedux.includes('sellers')) {
            setState('sellers')
        }
        else if (stateFromRedux.includes('sellerInfo')) {
            setState('sellerInfo')
        }
        else if (stateFromRedux.includes('wallet')) {
            const newCleanUrl = `${window.location.origin}/#/`;
            window.history.replaceState(null, '', newCleanUrl);
            setState('wallet')
        }
        else if (stateFromRedux.includes('purchaseRecordDetail')) {
            setState('purchaseRecordDetail');

        } else if (stateFromRedux.includes('purchaseRecords')) {
            setState('purchaseRecords')
        }

    }, [stateFromRedux])
    useEffect(() => {
        if (stateReduxBottomNav.includes('store')) {

            setState('store');
        } else if (stateReduxBottomNav.includes('wallet')) {
            setState('wallet')
        }
    }, [stateReduxBottomNav])

    const currentState = {
        'store': <StoreTab setState={setState} setTabChild={setTabChild} />,
        'sellers': <Sellers setState={setState} setTabChild={setTabChild} />,
        'sellerInfo': <SellerInfo setState={setState} />,
        'storeBranches': <StoreBranches />,
        'wallet': <Wallet setTabChild={setTabChild} setState={setState} />,
        'purchaseRecords': <WalletFlow setState={setState} />,
        'purchaseRecordDetail': <PurchaseRecordDetail />,
    }
    return (
        <div>
            {currentState[state!]}
        </div>
    )
}
